import { Droplets, HeartPulse, Leaf, ShieldCheck, Sparkles, Sun } from "lucide-react";

export const SITE = {
  name: "Medina Lia",
  legal: "Medina Lia Company LLC",
  tagline: "Nature, bottled with intention.",
  email: "wellness@medinaliacompany.com",
  phone: "+1 609 697 0070",
  phoneHref: "+16096970070",
  address: "3962 Taft Ave, Seaford, NY 11783, USA",
};

const IMG = {
  original:
    "https://static.prod-images.emergentagent.com/jobs/aee6d77a-dd9f-4ee4-8ce1-2cc2f5188078/images/269f060ec786809eaebd58b17995108ddeebd15a0d1a28bb319cbcfab6c1621f.jpeg",
  honey:
    "https://static.prod-images.emergentagent.com/jobs/aee6d77a-dd9f-4ee4-8ce1-2cc2f5188078/images/86e94b3d6a8cdfe1777748375a5c74a553c4467fb398a101ff20dc6a80c835e6.jpeg",
  gummies:
    "https://static.prod-images.emergentagent.com/jobs/aee6d77a-dd9f-4ee4-8ce1-2cc2f5188078/images/6ae5d6cfa4cf7211e6d98eaf50eb6cd6f13785234e4cc9ca035b95d7b83e913b.jpeg",
  capsules:
    "https://static.prod-images.emergentagent.com/jobs/aee6d77a-dd9f-4ee4-8ce1-2cc2f5188078/images/142b394a304b7abc1e830b8747044f4332efd8cac10991d17a19b809c8b01483.jpeg",
  ginger:
    "https://static.prod-images.emergentagent.com/jobs/aee6d77a-dd9f-4ee4-8ce1-2cc2f5188078/images/6627d398db49cd51ace11a8206bc9b4de59700fcfe3a34ec4d3b7e6d0dbc14e3.jpeg",
  detox:
    "https://static.prod-images.emergentagent.com/jobs/aee6d77a-dd9f-4ee4-8ce1-2cc2f5188078/images/f2b2251b2094acffd250afdee17e5829a376f6acaad9388846577612516fe00b.jpeg",
};

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/aee6d77a-dd9f-4ee4-8ce1-2cc2f5188078/images/d6dad577be876b3a1386003ceaaef54f3ba7c1ca86d50eea0f6ace74c2754eae.jpeg";

export const STORY_IMG = "https://images.unsplash.com/photo-1619566636858-adf3ef46400b";
export const LIFESTYLE_IMG = "https://images.unsplash.com/photo-1506126613408-eca07ce68773";

export const PRODUCTS = [
  {
    id: "acv-original",
    name: "The Original",
    subtitle: "Raw & Unfiltered Apple Cider Vinegar",
    price: "$18",
    size: "16 fl oz",
    image: IMG.original,
    tag: "Bestseller",
    description:
      "Our signature raw, unfiltered apple cider vinegar with the living 'Mother'. Slow-fermented from organically grown apples for a bright, mellow bite.",
    highlights: ["With the Mother", "Organic apples", "Naturally fermented", "Never pasteurized"],
  },
  {
    id: "acv-honey",
    name: "Honey Reserve",
    subtitle: "Apple Cider Vinegar with Raw Honey",
    price: "$22",
    size: "16 fl oz",
    image: IMG.honey,
    tag: "Smooth",
    description:
      "A gentler daily tonic — our raw vinegar softened with wildflower honey. Sweet, warming and easy to sip morning or night.",
    highlights: ["Raw wildflower honey", "Soothing on the palate", "Daily wellness ritual"],
  },
  {
    id: "acv-gummies",
    name: "Daily Gummies",
    subtitle: "Apple Cider Vinegar Gummies",
    price: "$24",
    size: "60 gummies",
    image: IMG.gummies,
    tag: "New",
    description:
      "All the benefits of ACV without the tang. Chewable gummies with added B12 and beetroot — a delicious way to stay consistent.",
    highlights: ["With B12 & beetroot", "No harsh acidity", "Vegan friendly"],
  },
  {
    id: "acv-capsules",
    name: "Pure Capsules",
    subtitle: "Apple Cider Vinegar Capsules",
    price: "$21",
    size: "90 capsules",
    image: IMG.capsules,
    tag: "On-the-go",
    description:
      "Concentrated ACV in a convenient capsule. Perfect for travel and busy mornings when a sip isn't practical.",
    highlights: ["Concentrated dose", "Easy to swallow", "Travel ready"],
  },
  {
    id: "acv-ginger",
    name: "Ginger & Turmeric",
    subtitle: "Apple Cider Vinegar Tonic",
    price: "$23",
    size: "16 fl oz",
    image: IMG.ginger,
    tag: "Warming",
    description:
      "Our raw vinegar infused with fresh ginger and golden turmeric. A warming, invigorating blend crafted for cozy comfort.",
    highlights: ["Fresh ginger root", "Golden turmeric", "Warming spice blend"],
  },
  {
    id: "acv-detox",
    name: "Reset Tonic",
    subtitle: "ACV Detox with Lemon & Mint",
    price: "$23",
    size: "16 fl oz",
    image: IMG.detox,
    tag: "Refreshing",
    description:
      "A crisp, refreshing reset — apple cider vinegar with cold-pressed lemon and cooling mint. Bright, clean and revitalizing.",
    highlights: ["Cold-pressed lemon", "Cooling mint", "Refreshing finish"],
  },
];

export const BENEFITS = [
  {
    icon: HeartPulse,
    title: "Supports Digestion",
    text: "The living Mother and natural enzymes help support a balanced, comfortable gut.",
  },
  {
    icon: Sparkles,
    title: "Radiant Skin",
    text: "Rich in acetic acid and antioxidants that complement a healthy skincare routine.",
  },
  {
    icon: Sun,
    title: "Steady Energy",
    text: "A gentle daily ritual to help you feel balanced and energized from the inside out.",
  },
  {
    icon: ShieldCheck,
    title: "Immune Friendly",
    text: "Naturally fermented goodness to support your everyday wellbeing and resilience.",
  },
  {
    icon: Leaf,
    title: "Clean & Organic",
    text: "Made from organically grown apples — no additives, no fillers, nothing artificial.",
  },
  {
    icon: Droplets,
    title: "With the Mother",
    text: "Unfiltered and unpasteurized so the beneficial strands stay alive in every bottle.",
  },
];

export const VALUES = [
  { number: "01", title: "Grown, not manufactured", text: "We start with real, organically grown apples — never concentrates or shortcuts." },
  { number: "02", title: "Slow fermentation", text: "Time is our secret ingredient. We let nature do the work, unhurried and honest." },
  { number: "03", title: "Radically transparent", text: "Simple labels, honest ingredients, and nothing we wouldn't give our own family." },
];

export const FAQS = [
  {
    q: "What does 'with the Mother' mean?",
    a: "The 'Mother' is the cloudy strand of proteins, enzymes and beneficial bacteria formed during natural fermentation. It's a sign your vinegar is raw, unfiltered and full of good stuff. A little sediment is completely normal — just give the bottle a gentle shake.",
  },
  {
    q: "How do I use apple cider vinegar daily?",
    a: "A common ritual is 1–2 teaspoons diluted in a large glass of water, ideally before meals. You can also add it to dressings, tonics or warm water with honey. Always dilute — never drink it straight, as the acidity can be hard on teeth and throat.",
  },
  {
    q: "Are your products organic?",
    a: "Yes. Our vinegars are crafted from organically grown apples with no artificial additives, colors or preservatives. We keep our ingredient lists short and honest.",
  },
  {
    q: "Do I need to refrigerate the vinegar?",
    a: "Refrigeration isn't required, but storing in a cool, dark place keeps the flavor at its best. Once opened, our tonics stay fresh for months.",
  },
  {
    q: "Are these products suitable for vegans?",
    a: "Most of our range is vegan friendly. The only exception is our Honey Reserve, which contains raw wildflower honey. Every label clearly lists its ingredients.",
  },
  {
    q: "Do you ship nationwide?",
    a: "Yes, we ship across the United States. Orders are typically processed within 1–2 business days. See our Shipping Policy for full details.",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Benefits", to: "/benefits" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Shipping Policy", to: "/shipping" },
  { label: "Return Policy", to: "/returns" },
];
